import Alert from './Alert'
import AlertWithRedirect from './AlertWithRedirect'

interface Props {
  exitUrl?: string
}

export default function ErrorMessage({ exitUrl }: Props) {
  const message = "Une erreur s'est produite sur votre parcours. Veuillez nous excuser pour la gêne occasionnée."

  return (
    <div className="flex justify-center p-4">
      {exitUrl ? (
        <AlertWithRedirect
          color="error"
          alertMessage={message}
          redirectMessage={document.referrer.length > 0 ? 'la page précédente' : "la page d'accueil"}
          urlToRedirect={document.referrer.length > 0 ? document.referrer : exitUrl}
        />
      ) : (
        <Alert color="error">{message}</Alert>
      )}
    </div>
  )
}
